import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { mapActions} from "vuex"
import { loadMoreList, commonData } from "@/mixins/index";
import addLoginType from "./components/addLoginType";
export default {
  name: "loginTypeList",
  mixins: [loadMoreList, commonData],
  components: {
    addLoginType: addLoginType
  },
  data: function data() {
    return {
      pagingReqFn: "appLoginTypeData",
      delIds: [],
      loginData: ''
    };
  },
  activated: function activated() {
    this.getcommonData(['appLoginTypeRes']);
    this.getList();
  },
  methods: {
    // ...mapActions("d2admin/init", ["getDataList"]),
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'appLoginTypeDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    },
    payTypeChange: function payTypeChange(e) {
      if (e) {
        var data = this.appLoginTypeRes.find(function (i) {
          return i.id == e;
        });
        this.paramsData.o_type = data.o_type;
        this.paramsData.type_name = data.type_name;
      } else {
        this.paramsData.type_name = '';
        this.paramsData.o_type = '';
      }
    }
  } // beforeRouteLeave(to, from, next) {
  //   this.getDataList('appLoginTypeRes')
  //   next()
  // },

};